import React, { useContext } from "react";
import { toast } from "react-toastify";
import { useSetupNegotiationAgent } from "../../../../services/negotiation/negotiationService";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const TurnOffLorriAgentModal = ({
  item,
  onClose,
  company_id,
  fetchSpotData,
  currentFilterPayload,
}) => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const { mutate: setupNegotiationAgent, isPending } = useSetupNegotiationAgent();

  const origin = item?.lane_details?.origin?.location_name;
  const destination = item?.lane_details?.destination?.location_name;

  const handleTurnOff = () => {
    setupNegotiationAgent(
      [
        {
          truck_enquiry_id: item?.truck_enquiry_id,
          agent_enabled: false,
          // company_id,
        },
      ],
      {
        onSuccess: (res) => {
          if (!res?.[0]?.error) {
            toast.success(res?.messages || "LoRRI Agent turned off");
            TrackMixPanel({
              ModuleName: "lorri spot",
              ScreenName: "my enquiries - turn off lorri agent",
              Data: `lane: ${origin} to ${destination}`,
              Definition: `user turned off LoRRI Agent for an enquiry`,
            });
            if (fetchSpotData && currentFilterPayload) {
              fetchSpotData(currentFilterPayload);
            }
            onClose && onClose();
          } else {
            toast.error(res?.message || "Something went wrong");
          }
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  return (
    <div style={{ padding: "8px 4px" }}>
      <div style={{ fontWeight: 700, color: "#393185", fontSize: "15px" }}>
        {origin} → {destination}
      </div>
      <div style={{ color: "#6b7280", fontSize: "13px", marginTop: "8px" }}>
        LoRRI Agent is currently negotiating this enquiry. Turning it off will
        stop the AI from placing further offers on this lane.
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <button
          type="button"
          className="btn btn-sm"
          style={{ border: "1px solid #cdd3de" }}
          onClick={() => onClose && onClose()}
          disabled={isPending}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm"
          style={{
            background: "#dc2626",
            color: "#fff",
            fontWeight: 600,
            border: "none",
            padding: "6px 16px",
          }}
          onClick={handleTurnOff}
          disabled={isPending}
        >
          {isPending ? "Turning off…" : "Turn off LoRRI Agent"}
        </button>
      </div>
    </div>
  );
};

export default TurnOffLorriAgentModal;
